import type { I18nOptions } from 'vue-i18n';

import { TRANSLATIONS as TRANSLATIONS1 } from '@/components/Admin/AdminSettings/admin-settings.i18n';
import { TRANSLATIONS as TRANSLATIONS2 } from '@/components/Admin/admin.i18n';
import { TRANSLATIONS as TRANSLATIONS3 } from '@/components/Advisor/advisor.i18n';
import { TRANSLATIONS as TRANSLATIONS8 } from '@/components/Client/Dashboard/dashboard.i18n';
import { TRANSLATIONS as TRANSLATIONS10 } from '@/components/Funnel/funnel.i18n';
import { TRANSLATIONS as TRANSLATIONS11 } from '@/locale/global-translations.i18n';
import { TRANSLATIONS as TRANSLATIONS12 } from '@/components/Client/Incorporation/incorporation.i18n';
import { TRANSLATIONS as TRANSLATIONS13 } from '@/components/Funnel/GeneralFlowFunnel/jobs.i18n';
import { TRANSLATIONS as TRANSLATIONS14 } from '@/components/Client/Liquidation/liquidation.i18n';
import { TRANSLATIONS as TRANSLATIONS15 } from '@/components/Client/Organization/organization.i18n';
import { TRANSLATIONS as TRANSLATIONS16 } from '@/components/Client/Organization/components/organizations-shareholders.i18n';
import { TRANSLATIONS as TRANSLATIONS17 } from '@/locale/page-metadata.i18n';
import { TRANSLATIONS as TRANSLATIONS18 } from '@/locale/process.i18n';
import { TRANSLATIONS as TRANSLATIONS19 } from '@/components/Global/Sidebar/SidebarNavigationItems/SidebarNavigationItems.i18n';
import { TRANSLATIONS as TRANSLATIONS20 } from '@/components/Start/start.i18n';
import { TRANSLATIONS as TRANSLATIONS21 } from '@/locale/tags.i18n';
import { TRANSLATIONS as TRANSLATIONS22 } from '@/components/ThankYou/thank-you.i18n';
import { TRANSLATIONS as TRANSLATIONS24 } from '@/components/Client/UboRegistration/ubo-process.i18n';
import { TRANSLATIONS as TRANSLATIONS25 } from '@/components/Start/UboRegistration/ubo.i18n';
import { TRANSLATIONS as TRANSLATIONS26 } from '@/components/UserAccount/user-account.i18n';
import { TRANSLATIONS as TRANSLATIONS27 } from '@/features/admin/share-transfer-process/share-transfer.i18n';
import { TRANSLATIONS as TRANSLATIONS28 } from '@/shared/forms/messages.i18n';
import { TRANSLATIONS as TRANSLATIONS29 } from '@/shared/forms/business/messages.i18n';

type TranslationFile = {
    nl: any;
    en: any;
};

const files = [
    TRANSLATIONS1,
    TRANSLATIONS2,
    TRANSLATIONS3,
    TRANSLATIONS8,
    TRANSLATIONS10,
    TRANSLATIONS11,
    TRANSLATIONS12,
    TRANSLATIONS13,
    TRANSLATIONS14,
    TRANSLATIONS15,
    TRANSLATIONS16,
    TRANSLATIONS17,
    TRANSLATIONS18,
    TRANSLATIONS19,
    TRANSLATIONS20,
    TRANSLATIONS21,
    TRANSLATIONS22,
    TRANSLATIONS24,
    TRANSLATIONS25,
    TRANSLATIONS26,
    TRANSLATIONS27,
    TRANSLATIONS28,
    TRANSLATIONS29,
];

const messages: TranslationFile = {
    nl: {},
    en: {},
};

files.forEach((file) => {
    Object.keys(file).forEach((f) => {
        const key = f.toLowerCase();
        Object.keys(file[f]).forEach((ff) => {
            messages[key][ff] = file[f][ff];
        });
    });
});

export default messages as I18nOptions['messages'];
